

module.exports = __webpack_require__.stylable.create(
    "DailySessions4017520207",
    {"classes":{"root":"DailySessions4017520207__root","day":"DailySessions4017520207__day","sessionsWrapper":"DailySessions4017520207__sessionsWrapper","sessions":"DailySessions4017520207__sessions"},"vars":{},"stVars":{},"keyframes":{}},
    "",
    1,
    "DailySessions4017520207",
    null
);
